import { FC } from "react";
import ToolCallCard from "./ToolCallCard";
import { ToolCallState } from "@/store/documentChatRuntime";

/**
 * Renders a list of tool call status cards for the current assistant operation.
 */
const ToolCallList: FC<{ toolCalls: ToolCallState[] }> = ({ toolCalls }) => {
  return (
    <div className="grid gap-2">
      {/* Each entry shows a spinner or checkmark with a humanized tool name */}
      {toolCalls.map((tc) => (
        <ToolCallCard key={tc.id} toolName={tc.toolName} status={tc.status} />
      ))}
    </div>
  );
};

export default ToolCallList;
